const STORAGE_KEY = "saased.languagePref.v1";

function clearGoogTransCookie() {
  if (typeof document === "undefined") return;
  const host = window.location.hostname;
  const parts = host.split(".");
  const domains = [host, "." + host];
  if (parts.length > 1) {
    const root = "." + parts.slice(-2).join(".");
    domains.push(root);
  }
  for (const d of domains) {
    document.cookie = `googtrans=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${d}`;
  }
  document.cookie = "googtrans=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
}

export function EnglishLanguageButton({ className = "" }: { className?: string }) {
  const handleClick = () => {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ pref: "english", lang: "en", at: Date.now() })
      );
    } catch {
      // ignore
    }

    const combo = document.querySelector(".goog-te-combo") as HTMLSelectElement | null;
    if (combo) {
      combo.value = "en";
      combo.dispatchEvent(new Event("change"));
    }

    clearGoogTransCookie();

    // Reload to guarantee a clean revert to the original English DOM.
    window.location.reload();
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label="View website in English"
      className={`inline-flex items-center gap-2 rounded-full border border-border/70 bg-background/60 px-3 py-1.5 font-sans text-xs font-medium uppercase tracking-[0.15em] text-foreground transition-colors hover:bg-background ${className}`}
    >
      <img
        src="https://flagcdn.com/w40/gb.png"
        alt=""
        aria-hidden="true"
        width="20"
        height="15"
        loading="lazy"
        decoding="async"
        fetchPriority="low"
        className="h-auto w-5 object-contain rounded-sm"
      />
      <span translate="no">English</span>
    </button>
  );
}
